// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__28N19","description":"PatientConsentPreview_description__3S_1x"};